import * as Sentry from "@sentry/react"
import { isLocalDev } from "./general"

export const isSentryEnabled = !isLocalDev

export const openProblemReport = async () => {
  const feedback = Sentry.getFeedback()
  if (feedback === undefined) {
    throw new Error("Sentry feedback is not initialised")
  }
  const form = await feedback.createForm({
    onFormClose: () => form.removeFromDom(),
    onFormSubmitted: () => form.removeFromDom(),
  })
  form.appendToDom()
  form.open()
}
